import type { Tenant, WorkspaceDetailHeaderPresentation } from '~/types/models';

export const DEFAULT_DETAIL_HEADER_PRESENTATION: WorkspaceDetailHeaderPresentation = 'immersive';

export function normalizeDetailHeaderPresentation(
    value: unknown,
): WorkspaceDetailHeaderPresentation {
    return value === 'contained' ? 'contained' : DEFAULT_DETAIL_HEADER_PRESENTATION;
}

export function resolveWorkspaceDetailHeaderPresentation(
    tenant?: Pick<Tenant, 'workspaceAppearance'> | null,
): WorkspaceDetailHeaderPresentation {
    return normalizeDetailHeaderPresentation(tenant?.workspaceAppearance?.detailHeaderPresentation);
}

export function resolvePortalDetailHeaderPresentation(
    tenant?: Pick<Tenant, 'portalBranding'> | null,
): WorkspaceDetailHeaderPresentation {
    return normalizeDetailHeaderPresentation(tenant?.portalBranding?.detailHeaderPresentation);
}
